import type {Address} from './client';

export enum PaymentProvider {
  BARTE = 'barte',
  CDC = 'cdc',
  E2 = 'e2',
  FIRE = 'fire',
  AVISTA = 'avista',
  PAYTIME = 'paytime',
  SANDBOX = 'sandbox',
  TRANSFEERA = 'transfeera',
  WEPAYMENTS = 'wepayments',
  LYTEX = 'lytex',
  WOOVI = 'woovi',
  PLUTECH = 'plutech',
  MARLIM = 'marlim',
  PAGARE = 'pagare',
  ONLYUP = 'onlyup',
}

export interface FireCredentials {
  apiKey: string;
  barteApiKey?: string;
  barteSandbox?: boolean;
}

export interface CdcCredentials {
  sandbox?: boolean;
  in: {
    pixKey?: string;
    mtlsCert: string;
    mtlsKey: string;
    clientKey: string;
    clientSecret: string;
  };

  out: {
    clientKey: string;
    clientSecret: string;
  };
}

export interface PixBacenCredentials {
  sandbox?: boolean;
  in: {
    pixKey?: string;
    mtlsCert: string;
    mtlsKey: string;
    mtlsCa?: string;
    clientKey: string;
    clientSecret: string;
    mtlsPfx: string;
    mtlsPassphrase: string;
  };

  out: {
    clientKey: string;
    clientSecret: string;
  };
}

export interface WepaymentsCredentials {
  apiKey?: string;
  merchantId?: number;
  sandbox?: boolean;
}

export interface PaymentProviderSettings {
  // Se true, todas as transações e displays de saldo serão conciliadas pelo provider. Nossos calculos internos serão ignorados.
  transactionProxy: boolean;

  // Se true, habilita o envio de onboardings para o provider.
  onboarding: boolean;

  requiresBankAccount?: boolean;

  creditCard?: {
    antifraud: boolean;
  };
}

export interface PaymentProviderCapabilities {
  creditCardTokenization: boolean;
  pixOutTransfer: boolean;
  pixOutQrCode: boolean;
  tedOutBankSlip: boolean;
  tedOutTransfer: boolean;
  pixKeyCheck: boolean;
}

export interface TransfeeraCredentials {
  clientId: string;
  clientSecret: string;
  sandbox: boolean;
  pixKey: string;
}

export interface PaytimeCredentials {
  sandbox?: boolean;
  'authentication-key': string;
  'integration-key': string;
  'x-token': string;
  antiFraudPublicKey: string;
  establishmentId: string;
  Authorization?: string;
}

export interface AvistaCredentials {
  sandbox?: boolean;
  clientId: string;
  clientSecret: string;
  mtlsCert: string; // Base64-encoded PEM certificate for X-SSL-Client-Cert header
}

export interface LytexCredentials {
  sandbox?: boolean;
  apiKey: string;
  apiSecret: string;
  recipientId?: string; // Lytex recipient ID (sub-account ID)
}

export interface WooviCredentials {
  sandbox?: boolean;
  appId: string; // Woovi AppID for authentication
}

export interface PlutechCredentials {
  sandbox?: boolean;
  apiKey: string;
  apiSecret: string;
}

export type PaymentProviderSettingDefinition = {
  [K in PaymentProvider]?: PaymentProviderSettings;
};

export interface MarlimCredentials {
  sandbox?: boolean;
  apiKey?: string;
  subSellerId?: string;
  address?: Partial<Address>;
}

export interface PagareCredentials {
  sandbox?: boolean;
  tenantKey: string;
  username: string;
  password: string;
  accountId?: string;
  signingSecret?: string;
}

export interface OnlyUpCredentials {
  sandbox?: boolean;
  in: {
    pixKey: string;
    clientId: string;
    clientSecret: string;
    mtlsCert: string;
    mtlsKey: string;
    mtlsPfx: string;
    mtlsPassphrase: string;
  };
  out: {
    clientId: string;
    clientSecret: string;
    mtlsCert: string;
    mtlsKey: string;
    mtlsPfx: string;
    mtlsPassphrase: string;
  };
}
